const i = (r, o, t) => {
  const a = !!r && !!o, d = t !== "none", e = {
    tabIndex: a ? 0 : r ? -1 : 0,
    "aria-disabled": r
  }, n = d ? { [t]: r && !o } : {};
  return {
    ...e,
    ...n
  };
};
export {
  i as getDisabledAria
};
//# sourceMappingURL=index.es530.js.map
